module.exports = __webpack_public_path__ + "img/pa.02e797ac.svg";